export default __webpack_public_path__ + "static/media/ordenar-button-mobile.432bc6c0.svg";